import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  loginHistoryList: [],
}

export const getters = {}

export const mutations = {
  CACHE_LOGINHISTORY_LIST(state, newList) {
    state.loginHistoryList = newList
  },
}

export const actions = {
  fetchLoginHistoryList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/login-history?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_LOGINHISTORY_LIST', list)
        return list
      })
  },
}
